import { useSimulationStore } from '../../../store/simulationStore';

/**
 * History controls for undo/redo operations
 * Keyboard shortcuts are handled globally by useKeyboardShortcuts hook
 */
export const HistoryControls = () => {
  const canUndo = useSimulationStore((state) => state.canUndo);
  const canRedo = useSimulationStore((state) => state.canRedo);
  const undo = useSimulationStore((state) => state.undo);
  const redo = useSimulationStore((state) => state.redo);
  
  return (
    <div className="history-controls">
      <button
        onClick={undo}
        disabled={!canUndo}
        title="Undo (⌘Z)"
        className="history-button"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-20"
        >
          <path d="M3 7v6h6" />
          <path d="M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13" />
        </svg>
      </button>
      <button
        onClick={redo}
        disabled={!canRedo}
        title="Redo (⌘⇧Z)"
        className="history-button"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-20"
        >
          <path d="M21 7v6h-6" />
          <path d="M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7" />
        </svg>
      </button>
    </div>
  );
};

